module.exports = __webpack_public_path__ + "static/media/restaurant4.d95e5788.jpg";